import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // No token at all - redirect to login
  if (!authService.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  // Token exists but expired - try to refresh
  if (authService.isTokenExpired()) {
    if (authService.hasRefreshToken()) {
      return authService.refreshSession().pipe(
        map(() => true),
        catchError(() => {
          authService.logout(true);
          return of(false);
        })
      );
    }
    // No refresh token - session expired
    authService.logout(true);
    return false;
  }

  return true;
};

export const shopGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Superadmin should only see admin panel
  if (authService.isSuperAdmin()) {
    router.navigate(['/admin']);
    return false;
  }

  return true;
};

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAdmin()) {
    return true;
  }

  router.navigate(['/']);
  return false;
};

export const superadminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isSuperAdmin()) {
    return true;
  }

  router.navigate(['/']);
  return false;
};
